import React from 'react';
import Routes from './Pages/Routes';

function App() {
  return <div className='App'><Routes/></div>;
}

export default App;
